<template>
    <div class="info_form">
        <!-- tab -->
        <div class="tab_box">
            <div class="tab_item" v-for="(item, index) in TabList" :key="index" :class="TabCur == index ? 'active_tab' : '' " @click="TabClick(item, index)" >
                {{ item }}
            </div>
        </div>
        <!-- 个人信息 -->
        <div class="user_info" v-if="TabCur == 0">
            <!-- 提示信息 -->
            <div class="back_btn">
                <el-button type="danger" @click="goBack">返回个人中心</el-button>
            </div>
            <!-- 用户信息 -->
            <div class="info_box">
                <div class="avatar_box">
                    <img :src="userInfo.avatar" v-if="userInfo.avatar && userInfo.avatar.indexOf('http') != -1" alt="">
                    <img :src="$ImgUrl + userInfo.avatar" v-if="userInfo.avatar && userInfo.avatar.indexOf('http') == -1" alt="">
                    <img src="../../assets/static/index/default.png" v-if="!userInfo.avatar" alt="">
                    <el-upload
                        class="upload-demo"
                        ref="upload"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        :on-change="imgChange"
                        :auto-upload="false">
                        <el-button slot="trigger" size="small" type="primary">更换头像</el-button>
                    </el-upload>
                </div>
                <div class="info_form">

                    <div class="form_item">
                        <div class="items">
                            <span class="label"><span class="must">*</span>姓名:</span>
                            <div class="input_box">
                                <input type="text" v-model="userInfo.userName">
                            </div>
                        </div>
                        <div class="items">
                            <span class="label"><span class="must">*</span>性别:</span>
                            <div class="input_box">
                                <el-select v-model="userInfo.sex" placeholder="请选择">
                                    <el-option
                                    v-for="item in sexList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        
                    </div>

                    <div class="form_item">
                        <div class="items">
                            <span class="label">*民族:</span>
                            <div class="input_box">
                                <el-select v-model="userInfo.mz" placeholder="请选择民族">
                                    <el-option
                                    v-for="item in MinList"
                                    :key="item.mzId"
                                    :label="item.mzName"
                                    :value="item.mzId">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="items">
                            <span class="label"><span class="must">*</span>身份证号:</span>
                            <div class="input_box">
                                <input type="text" v-model="userInfo.partyMemberNumber">
                            </div>
                        </div>
                    </div>

                    <div class="form_item">
                        
                        <div class="items">
                            <span class="label">出生日期:</span>
                            <div class="input_box">
                                    <input type="text" v-model="userInfo.birthday" disabled>
                            </div>
                        </div>
                        <div class="items">
                            <span class="label"><span class="must">*</span>入党时间:</span>
                            <div class="input_box">
                                 <el-date-picker
                                    v-model="userInfo.entryPartyTime"
                                    type="date"
                                    placeholder="选择日期">
                                    </el-date-picker>
                            </div>
                        </div>
                    </div>

                    <div class="form_item">
                        <div class="items">
                            <span class="label">年龄:</span>
                            <div class="input_box">
                                <input type="text" v-model="userInfo.age" disabled>
                            </div>
                        </div>
                        <div class="items">
                            <span class="label">党龄:</span>
                            <div class="input_box">
                                <input type="text" v-model="userInfo.dyAge" disabled>
                            </div>
                        </div>
                    </div>

                    <div class="form_item">
                        <div class="items">
                            <span class="label"><span class="must">*</span>联系电话:</span>
                            <div class="input_box">
                                <input type="text" v-model="userInfo.phonenumber">
                            </div>
                        </div>
                        <div class="items">
                            <span class="label">学历:</span>
                            <div class="input_box">
                                <el-select v-model="userInfo.xueLi" placeholder="请选择学历">
                                    <el-option
                                    v-for="item in XueList"
                                    :key="item.dictValue"
                                    :label="item.dictName"
                                    :value="item.dictValue">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        
                    </div>

                  

                    <div class="form_item">
                        <div class="items">
                            <span class="label">所属党支部:</span>
                            <div class="input_box">
                                <input type="text" v-model="userInfo.deptName" disabled>
                            </div>
                        </div>
                        
                    </div>


                    <div class="form_item">
                        <div class="items">
                            <span class="label">家庭住址:</span>
                            <div class="input_box">
                                <input type="text" v-model="userInfo.homeAddress">
                            </div>
                        </div>
                        
                    </div>

                    <div class="btn_box">
                        <el-button @click="SaveUserInfo">保    存</el-button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 修改密码 -->
        <div class="change_password" v-if="TabCur == 1 ">

            <!-- <div class="user_items">
               <div class="labels">
                    用户名: 
               </div>
               <div class="values">
                   用户姓名
               </div>
            </div> -->

            <div class="user_items">
               <div class="labels">
                    旧密码: 
               </div>
               <div class="values">
                  <input type="password" v-model="passForm.old_password">
               </div>
            </div>

            <div class="user_items">
               <div class="labels">
                    新密码: 
               </div>
               <div class="values">
                  <input type="password" v-model="passForm.password">
               </div>
            </div>

            <div class="user_items">
               <div class="labels">
                    确认密码: 
               </div>
               <div class="values">
                  <input type="password" v-model="passForm.res_password">
               </div>
            </div>

            <div class="user_items">
                <el-button @click="changePassword">保      存</el-button>
            </div>


        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    export default {
        data() {
            return {
                TabList: ["个人信息", "修改密码"],
                TabCur: 0,
                options: [
                    { label: "小学", value: 0 },
                    { label: "初中", value: 1 },
                    { label: "高中", value: 2 },
                    { label: "大专", value: 3 },
                    { label: "本科", value: 4 },
                    { label: "博士", value: 5 },
                ], //  学历列表
                xueli: "",
                sexList: [
                   { label: "男", value: '0' },
                    { label: "女", value: '1' },
                ],
                passForm: {
                    password: "",
                    old_password: "",
                    res_password: "",
                },
                userInfo: {},
                XueList: [],
                MinList: [],
            }
        },
        computed: {
            ...mapGetters(['token']),
            joinYear () {
                return this.userInfo.entryPartyTime
            },
            idcard () {
                return this.userInfo.partyMemberNumber
            },
        },
        watch: {
            joinYear () {
                let nowYear = new Date().getFullYear()
                let jy = new Date( this.joinYear ).getFullYear()
                this.userInfo.dyAge = nowYear - jy
            },
            idcard() {
                this.ComputeBirthdayById()
            }
        },
        mounted () {
            this.getUserInfo();
            this.getCommonData()
            this.getMinList()
        },
        methods: {
            // 返回个人中心
            goBack () {
                this.$router.push("/user")
            },
            // 点击tab
            TabClick(item, index) {
                this.TabCur = index 
            },
            // 联机选择框变化
            handleChange ( e ) {
                console.log( e )
            },
            // 更爱密码
            async changePassword () {
                let { token } = this 
                this.passForm.token = token
                let { password, old_password,res_password } = this.passForm 
                console.log( this.passForm )
                if ( !old_password ) {
                    return this.$message.error("请输入原密码")
                } else if ( !password ) {
                    return this.$message.error("请输入新密码")
                } else if ( password != res_password ){
                    return this.$message.error("两次输入的密码不一致")
                } else {
                    let res = await this.$axios.post("/lencon/pc/person/member/changePassword", this.passForm )
                    this.$message.success( res.data.msg )
                    localStorage.removeItem("token")
                    this.$store.commit("getToken", "")
                    this.$router.push("/login")
                }
                
            },

            // 获取个人信息
            async getUserInfo () {
                let res = await this.$axios.post("/lencon/pc/person/member_info", { token: this.token })
                if ( res.data.code == 1 ) {
                    this.userInfo = res.data.obj
                    this.ComputeBirthdayById()
                }
            },

            // 根据身份证计算出生日期和年龄
            ComputeBirthdayById () {
                let id = this.userInfo.partyMemberNumber
                if ( id.length == 18 ) {
                   let birthday = id.substr(6,8); 
                   birthday = birthday.replace(/(.{4})(.{2})/,"$1-$2-")
                   let arr = birthday.split("-")
                   let age = new Date().getFullYear() - Number( arr[0] )
                   this.userInfo.birthday = birthday
                   this.userInfo.age = age
                }
            },

            // 获取学历
            async getCommonData () {
                let res = await this.$axios.post("/lencon/pc/common/dataList", { type: "education_types" })
                if ( res.data.code == 1 ) {
                    this.XueList = res.data.res
                    
                }
            },
            // 获取民族
            async getMinList () {
                let res = await this.$axios.post("/lencon/pc/common/mzLists")
                if ( res.data.code == 1 ) {
                    this.MinList = res.data.res
                    this.MinList.forEach( el => {
                        el.mzId = `${ el.mzId }`
                    })
                }
            },

            // 保存用户信息
            async SaveUserInfo () {
                let { token } = this 
                this.userInfo.token = token
                let { userName, sex,partyMemberNumber, phonenumber,birthday,entryPartyTime } = this.userInfo
                if ( !userName ) {
                    return this.$message.error("用户姓名必填")
                } else if ( !sex ) {
                    return this.$message.error("用户性别必填")
                } else if ( !partyMemberNumber ) {
                    return this.$message.error("用户身份证必填")
                } else if ( !phonenumber ) {
                    return this.$message.error("用户手机号码必填")
                } else if ( !birthday ) {
                    return this.$message.error("用户出生日期必填")
                } else if ( !entryPartyTime ) {
                    return this.$message.error("用户入党时间必填")
                } else {
                    let res = await this.$axios.post("/lencon/pc/person/saveMemberInfo", this.userInfo)
                    this.$message.success( res.data.msg )
                    this.getUserInfo()
                }
            },

            // 上传图片变化
            async imgChange ( file ) {
                console.log( file )
                let { token } = this 
                let FD = new FormData()
                FD.append("file_name", "new_headpic")
                FD.append("new_headpic", file.raw)
                let res = await this.$axios.post("/lencon/app/common/upload", FD)
                if ( res.data.code == 1 ) {
                    this.$refs.upload.clearFiles()
                    let avatar = res.data.data[0]
                    let info = await this.$axios.post("/lencon/pc/person/changeAvatar", { token, avatar })
                    if ( res.data.code == 1 ) {
                        this.getUserInfo()
                    }
                    
                }
            }
        },
    }
</script>
<style>
.el-input__inner {
    border: none;
}
</style>

<style lang="scss" scoped>
.info_form {
    width: 1200px;
    margin: 20px auto;
    background-color: #fff;
    padding: 20px;
    .tab_box {
        display: flex;
        font-size: 20px;
        .tab_item {
            width: 100px;
            text-align: center;
            line-height: 50px;
            cursor: pointer;
        }
        .active_tab {
            font-weight: bold;
            color: #2767c4 ;
            border-bottom: 2px solid #2767c4 ;
        }
    }
    .user_info {
        width: 100%;
        padding-top: 30px;
        .back_btn {
            text-align: right;
        }
        .tips_info {
            display: flex;
            justify-content: space-between;
            line-height: 60px;
        }
        .info_box {
            width: 100%;
            display: flex;
            .avatar_box {
                text-align: center;
                img {
                    width: 130px;
                    height: 130px;
                    border-radius: 50%;
                    overflow: hidden;
                }
                .el-button {
                    margin-top: 20px;
                    // background-color: #eee;
                }
            }
            .info_form {
                margin-left: 20px;
                flex: 1;
                .form_item {
                    display: flex;
                    align-items: center;
                    margin-bottom: 30px;
                    .items {
                        flex: 1;
                        display: flex;
                        align-items: center;
                        .label {
                            font-size: 16px;
                            width: 120px;
                            text-align: right;
                            .must {
                                color: #2767c4 ;
                            }
                        }
                        
                        .input_box {
                            margin-left: 10px;
                            flex: 1;
                            input {
                                width: 307px;
                                height: 45px;
                                border: 1px solid #E3E1E1;
                                border-radius: 5px;
                                padding-left: 10px;
                            }
                            .el-select {
                                width: 307px;
                                height: 45px;
                                border: 1px solid #E3E1E1;
                                border-radius: 5px;
                                line-height: 45px;
                            }
                        }
                    }
                }
                .btn_box {
                    text-align: center;
                    .el-button {
                        width: 241px;
                        height: 55px;
                        background: #2767c4 ;
                        border-radius: 5px;
                        color: #fff;
                        font-size: 18px;
                    }
                }
            }
        }
    }
    .change_password {
        width: 100%;
        .user_items {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 20px 0;
            .labels {
                width: 120px;
                text-align: right;
            }
            .values {
                width: 483px;
                margin-left: 10px;
                input {
                    width: 483px;
                    height: 47px;
                    border: 1px solid #E3E1E1;
                    border-radius: 5px;
                    padding-left: 10px;
                }
                
            }
            .el-button {
                    width: 241px;
                    height: 55px;
                    background: #2767c4 ;
                    border-radius: 5px;
                    color: #fff;
                    font-size: 18px;
                }
        }
    }
}
</style>